import Script from 'next/script';
import { useId, useRef } from 'react';
import { ComponentProps } from 'lib/component-props';

const AppCatalystWidget = (props: ComponentProps & { isSidenavPart: boolean | undefined }) => {
  // Default to the updated hardcoded url from App Catalyst
  const widgetUrl =
    props.params?.WidgetUrl || 'https://af.appcatalyst.com/api/app/AZq3peEqfgaE1Xe_3BzaDQ';

  const uniqueId = useId().replace(/:/g, '');
  const iframeId = `app-catalyst-${uniqueId}`;

  const isInitialized = useRef(false);

  return (
    <div
      className={`widget-wrapper ${!props?.isSidenavPart ? 'px-10 lg:px-20 max-w-screen-xxl mx-auto py-10 w-full' : ''}`}
    >
      <iframe
        id={iframeId}
        src={widgetUrl}
        className="overflow-hidden min-w-full w-[1px] border-0"
        title="Symptom Checker"
      />

      <Script
        src="https://af.appcatalyst.com/1/pub/iframe-embedder.js"
        strategy="afterInteractive"
        onReady={() => {
          if (!isInitialized.current && window.IFrameEmbedder) {
            console.log(`Initializing widget: ${iframeId}`);
            new window.IFrameEmbedder(`#${iframeId}`, null, {
              checkOrigin: ['https://af.appcatalyst.com'],
            });
            isInitialized.current = true;
          }
        }}
      />
    </div>
  );
};

export default AppCatalystWidget;
